import React from "react";
import { LucideIcon, MoreHorizontal } from "lucide-react";
import { Button } from "@/core/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/core/components/ui/dropdown-menu";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { cn } from "@/core/utils/func/cn";

export interface RowAction {
  /** Identifiant stable utilisé comme clé React (défaut : `label`). */
  id?: string;
  label: string;
  icon?: LucideIcon;
  onClick: () => void;
  variant?: "default" | "destructive";
}

interface RowActionsMenuProps {
  actions: RowAction[];
}

/**
 * Menu d'actions générique pour la colonne « Actions » d'une DataTableClar.
 * Chaque liste Flash Pay doit l'utiliser pour ses actions de ligne
 * (ex. Voir / Modifier / Supprimer).
 */
export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({ actions }) => {
  const { t } = useTypedTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">{t("openMenu")}</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" collisionPadding={12}>
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <DropdownMenuItem
              key={action.id ?? action.label}
              onClick={action.onClick}
              className={cn(
                action.variant === "destructive" &&
                  "text-destructive focus:text-destructive"
              )}
            >
              {Icon ? <Icon className="mr-2 h-4 w-4" /> : null}
              {action.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
